module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-about",
    class: _vm.displayedClass
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-about__content"
  }, [_c('p', [_vm._v("\n        Hey ! I’m Théo, a 22 years old interface designer and product manager (and maybe an ex web developper).\n        "), _c('br'), _vm._v("\n        I also do some photographs as an amateur : you could see some pictures I've taken "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://instagram.com/theokleman/"
    }
  }, [_vm._v("right here")]), _vm._v(".\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "last"
  }, [_vm._v("\n        Currently working on an awesome product called "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://across-app.com/"
    }
  }, [_vm._v("across")]), _vm._v(" with a bunch of friends ("), _c('a', {
    staticClass: "s-secondary",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/DominGo"
    }
  }, [_vm._v("@domingo")]), _vm._v(", "), _c('a', {
    staticClass: "s-secondary",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/rmnbrd"
    }
  }, [_vm._v("@rmnbrd")]), _vm._v(",\n        "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "s-secondary",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/ben_chrn"
    }
  }, [_vm._v("@ben_chrn")]), _vm._v(", "), _c('a', {
    staticClass: "s-secondary",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/Chokapix41"
    }
  }, [_vm._v("@chokapix41")]), _vm._v("). We made it to help marketing agencies to collect digital statistics\n        "), _c('br'), _vm._v("\n        on several networks and export beautiful campaign reports ! Check it !\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        If you have something you want to discuss, feel free to contact me :)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-about__content__socials"
  }, [_c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/theokleman"
    }
  }, [_vm._v("twitter")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://instagram.com/theokleman/"
    }
  }, [_vm._v("instagram")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.linkedin.com/in/theokleman"
    }
  }, [_vm._v("linkedin")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/TheoKleman/"
    }
  }, [_vm._v("github")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "mailto:theokleman.com"
    }
  }, [_vm._v("mail")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eecd200!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/About.vue
// module id = 87
// module chunks = 2